import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header.tsx';
import ErrorBoundary from './components/ErrorBoundary.tsx';
import Home from './pages/Home.tsx';
import Browse from './pages/Browse.tsx';
import Search from './pages/Search.tsx';
import CocktailDetail from './pages/CocktailDetail.tsx';
import Favorites from './pages/Favorites.tsx';
import { getStoredTheme, getTheme, applyTheme } from './services/themeService.ts';
import './App.css';

function App() {
  useEffect(() => {
    // Apply stored theme on app load
    const themeId = getStoredTheme();
    const theme = getTheme(themeId);
    applyTheme(theme);
  }, []);

  return (
    <ErrorBoundary>
      <Router>
        <div className="App">
          <ErrorBoundary>
            <Header />
          </ErrorBoundary>
          <main>
            <Routes>
              <Route path="/" element={<ErrorBoundary><Home /></ErrorBoundary>} />
              <Route path="/browse" element={<ErrorBoundary><Browse /></ErrorBoundary>} />
              <Route path="/search" element={<ErrorBoundary><Search /></ErrorBoundary>} />
              <Route path="/favorites" element={<ErrorBoundary><Favorites /></ErrorBoundary>} />
              <Route path="/cocktail/:id" element={<ErrorBoundary><CocktailDetail /></ErrorBoundary>} />
            </Routes>
          </main>
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
